import { fromJS } from 'immutable';

import orderFlowReducer from '@core/utils/orderFlowReducer';
import { successAction } from '@utils/actions';
import { INIT_STORE } from '@shared/actionTypes';

import * as actions from './actionTypes';
import ModuleStateModel, {
  PRODUCT,
  PRODUCT_OPTIONS_GROUPS,
  IS_FETCHING_ITEM_OPTIONS,
} from './model';

const initialState = ModuleStateModel;

function productConfigModuleReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_STORE:
      return ModuleStateModel.mergeDeep(state);

    case actions.FETCH_PROD_OPTIONS: {
      return state.set(IS_FETCHING_ITEM_OPTIONS, true);
    }

    case successAction(actions.FETCH_PRODUCT_OPTION_GROUPS): {
      const { productOptionsGroups } = action.payload;
      return state.set(PRODUCT_OPTIONS_GROUPS, fromJS(productOptionsGroups));
    }

    case successAction(actions.FETCH_PROD_OPTIONS): {
      const { product } = action.payload;
      return state
        .set(PRODUCT, fromJS(product))
        .set(IS_FETCHING_ITEM_OPTIONS, false);
    }

    case actions.RESET_MODULE:
      return initialState;

    default:
      return state;
  }
}

export default orderFlowReducer(productConfigModuleReducer, initialState);
